import React from 'react';
import { useObservable } from 'react-use-observable';

import { Checkbox, Empty, List as AntList, Spin, Typography } from 'antd';

import { useFormikContext } from 'formik';
import type { IAffiliateOption } from 'v2/interfaces/affiliate/selectAffiliate';
import selectAffiliateService from 'v2/services/affiliate/selectAffiliate';

interface IProps {
  affiliates: IAffiliateOption[];
  selectedQuantity: number;
  selectedAffiliates: IAffiliateOption[];
}

export const List = ({ affiliates, selectedAffiliates }: IProps) => {
  const { setFieldValue } = useFormikContext();

  const [isLoadingAffiliates] = useObservable(() => selectAffiliateService.getIsLoading(), []);

  const selectedAffiliatesId = selectedAffiliates.map(aff => aff.id);

  const handleSelectAffiliate = (affiliate: IAffiliateOption) => {
    const isAlreadySelected = selectedAffiliates.some(aff => aff.id === affiliate.id);

    if (isAlreadySelected) {
      const filteredAffiliates = selectedAffiliates.filter(aff => aff.id !== affiliate.id);

      setFieldValue('affiliates', filteredAffiliates);

      return;
    }

    setFieldValue('affiliates', [...selectedAffiliates, affiliate]);
  };

  const affiliatesSize = affiliates.length;

  return (
    <>
      {!!affiliatesSize && (
        <AntList
          className='max-h-[calc(80vh-240px)] overflow-auto max-sm:max-h-[calc(95vh-280px)]'
          dataSource={affiliates}
          rowKey='id'
          renderItem={affiliate => (
            <AntList.Item
              className='cursor-pointer px-2 hover:bg-(--uizz-antd-color-fill-quaternary)'
              onClick={() => handleSelectAffiliate(affiliate)}
            >
              <div className='flex items-center'>
                <Checkbox checked={selectedAffiliatesId.includes(affiliate.id)} />
                <div className='ml-4 flex flex-col'>
                  <Typography.Text strong>{affiliate.name}</Typography.Text>
                  <Typography.Text type='secondary'>{affiliate.email}</Typography.Text>
                </div>
              </div>
            </AntList.Item>
          )}
        />
      )}

      {!isLoadingAffiliates && !affiliatesSize && <Empty description='Nenhum afiliado encontrado' />}

      {isLoadingAffiliates && <Spin tip='Carregando afiliados...' />}
    </>
  );
};
